import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Pagination, Container, Segment, Header} from 'semantic-ui-react';

import { search, download } from '../../search/actions/itemSearchActions';

import ItemTable from './ItemTable';
import SearchForm from '../search/SearchForm';

class ItemIndexContainer extends Component {

    static LIMIT = 50;

    onSearchClick = (values) => {
        this.props.search({
            text: values.text,
            tags: values.tags,
            affix: values.affix,
            notoriety: values.notoriety,
            categories: values.categories,
            limit: ItemIndexContainer.LIMIT,
            minimumLevel: values.minimumLevel,
            maximumLevel: values.maximumLevel,
            minimumiLevel: values.minimumiLevel,
            maximumiLevel: values.maximumiLevel,
        });
    }

    onDownloadClick = () => {
        const {values} = this.props.searchOptions;

        this.props.download({
            text: values.text,
            tags: values.tags,
            affix: values.affix,
            notoriety: values.notoriety,
            categories: values.categories,
            limit: ItemIndexContainer.LIMIT,
            minimumLevel: values.minimumLevel,
            maximumLevel: values.maximumLevel,
            minimumiLevel: values.minimumiLevel,
            maximumiLevel: values.maximumiLevel,
        });
    }

    onPageChange = (e, data) => {
        const {parameters} = this.props.itemSearch;

        this.props.search({
            text: parameters.text,
            tags: parameters.tags,
            affix: parameters.affix,
            notoriety: parameters.notoriety,
            categories: parameters.categories,
            minimumLevel: parameters.minimumLevel,
            maximumLevel: parameters.maximumLevel,
            minimumiLevel: parameters.minimumiLevel,
            maximumiLevel: parameters.maximumiLevel,
            skip: (data.activePage - 1) * ItemIndexContainer.LIMIT,
            limit: ItemIndexContainer.LIMIT,
        });
    }

    render() {
        const {tags, categories} = this.props;
        const isLoading = this.props.itemSearch.isFetching;
        const {items, page, pages} = this.props.itemSearch.results;

        const pagination = pages > 1 ? <Pagination totalPages={pages} activePage={page} onPageChange={this.onPageChange} /> : <div />;

        return (
            <div>
                <Container>
                    <Header as="h3" attached='top'>
                        Search for items
                    </Header>
                    <Segment attached loading={isLoading}>
                        <SearchForm onSubmit={this.onSearchClick} onDownloadClick={this.onDownloadClick} tags={tags} categories={categories}/>
                    </Segment>
                    <ItemTable items={items} />
                    {pagination}
                </Container>
            </div>
        )
    }
};


const mapStateToProps = state => ({
    tags: state.tags.tags.items,
    categories: state.categoryState.categories.items,
    itemSearch: state.itemSearch,
    searchOptions: state.form.item_search,
});

const mapDispatchToProps = () => ({
    search,
    download,
});

export default connect(mapStateToProps, mapDispatchToProps())(ItemIndexContainer);


// WEBPACK FOOTER //
// ./src/items/index/ItemIndexContainer.jsx